export default __webpack_public_path__ + "static/media/join-us.4814dcca.png";